var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar",attrs:{"role":"toolbar"}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"top-bar__small"},[_vm._t("small")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }